<template>
  <Layout class="app-layout" :class="{'app-layout--collpase': isCollapsed || appBreakpoint}">
    <AppSider/>
    <Layout class="app-main">
      <AppHeader/>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
      <AppFooter/>
    </Layout>
  </Layout>
</template>
<script>
import Vue from 'vue'

import AppHeader from '../components/layout/AppHeader.vue'
import AppSider from '../components/layout/AppSider.vue'
import AppMenu from '../components/layout/AppMenu.vue'
import AppPageTitle from '../components/layout/AppPageTitle.vue'
import AppFooter from '../components/layout/AppFooter.vue'

Vue.component('AppPageTitle', AppPageTitle)
Vue.component('AppMenu', AppMenu)

export default {
  components: {
    AppHeader,
    AppSider,
    AppFooter
  },
  computed: {
    isCollapsed () {
      return this.$store.state.isCollapsed
    },
    appBreakpoint () {
      return this.$store.state.appBreakpoint
    }
  }
}
</script>
<style lang="less">
@import "../assets/less/base/variables.less";
.app-layout {
  background-color: @body-background;
  &.app-layout--collpase {
    .app-main {
      padding-left: 64px;
    }
    .app-header {
      left: 64px;
    }
    @media (max-width: 600px) {
      .app-main {
        padding-left: 0;
      }
      .app-header {
        left: 0;
      }
    }
  }
}
.app-main {
  padding-left: 216px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: auto;
  transition: all @animation-time;
  z-index: 1;
  background: transparent !important;
}
.app-content {
  padding: 56px 24px 0 24px;
  flex: auto;
  &__main {
    padding: 24px;
    margin: 24px 0;
    transition: all @animation-time;
    background: #fff;
    border-radius: 4px;
  }
}
</style>
